import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SignupService } from '../../../services/sigup.service';

@Component({
  selector: 'app-username',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './username.component.html',
  styleUrl: './username.component.scss'
})
export class UsernameComponent implements OnInit{
  userNames!: FormGroup;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private signupData: SignupService,
    ) {}

  ngOnInit(): void {
    this.signupuserNameData();
  }

  userNameData(data: any) {
    this.signupData.postUserName(data).subscribe({
      next: (response) => {
        if(response.success = true){
          this.router.navigate(['home']);
        }
      }
    });
  }

  signupuserNameData() {
    this.userNames = this.fb.group({
      username: ['',  [Validators.required, Validators.minLength(3), Validators.maxLength(15)]],
    })
  }
}
